import { Component, Input } from '@angular/core';
import { DocumentListLoadingService } from 'app/services/document-list-loading.service';

@Component({
    selector: 'app-tab-count',
    templateUrl: './tab-count.component.html',
    styleUrls: ['./tab-count.component.scss'],
})
export class TabCountComponent {
    @Input() count = 0;

    loading$ = this.listLoading.loading$;

    constructor(private listLoading: DocumentListLoadingService) {}
}
